import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[cdkDetailRow]',
  standalone: false,
})
export class CdkDetailRowDirective {
  private row: any;
  private tRef: TemplateRef<any>;
  private opened: boolean;
  private templates: any[];

  @Output() onValueChanged = new EventEmitter<any>();

  @Input()
  set cdkDetailRow(value: any) {
    if (value !== this.row) {
      this.row = value;
      // this.render();
    }
  }

  @Input()
  set cdkDetailRowTemplates(array: any) {
    array.push(this.vcRef);
    this.templates = array;
  }

  @Input('cdkDetailRowTpl')
  set template(value: TemplateRef<any>) {
    if (value !== this.tRef) {
      this.tRef = value;
      // this.render();
    }
  }

  constructor(
    public vcRef: ViewContainerRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('click')
  onClick(): void {
    this.toggle();
    setTimeout(() => {
      this.onValueChanged.emit(!this.vcRef.element.nativeElement.classList.contains('expanded'));
    });
  }

  toggle(): void {
    this.opened = this.vcRef.length > 0;

    if (this.opened) {
      this.vcRef.clear();
      this.renderer.removeClass(this.vcRef.element.nativeElement, 'expanded');
    } else {
      this.render();
    }
  }

  private render(): void {
    setTimeout(() => {
      this.templates.forEach((tpl) => {
        if (tpl.element.nativeElement !== this.vcRef.element.nativeElement) {
          tpl.clear();
        }
        this.renderer.removeClass(tpl.element.nativeElement, 'expanded');
      });
      this.vcRef.clear();
      if (this.tRef && this.row) {
        this.renderer.addClass(this.vcRef.element.nativeElement, 'expanded');
        this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
      }
    });
  }
}
